const LocalStorage ={
    getItem: (isPlugin, key)=> {
      if (!isPlugin) {
        const data = localStorage.getItem(key)
        return Promise.resolve(data)
      }
      if (typeof window?.postRobot?.sendToParent === 'function')
        return window?.postRobot?.sendToParent?.('getLocalStorageItem', { key }).then((e) => e.data)
      return Promise.reject("::: postRobot doesn't exist")
    },  
    setItem:(isPlugin, key, value)=> {
      if (!isPlugin) {
        localStorage.setItem(key, value)
        return Promise.resolve()
      }
      if (typeof window?.postRobot?.sendToParent === 'function')
        return window?.postRobot?.sendToParent?.('setLocalStorageItem', { key, value })
      return Promise.reject("::: postRobot doesn't exist")
    }
  }

  export default LocalStorage;